export const EVENTS = {
    TRANSACTIONS: "transactions",
    ORDER_UPDATED: 'order_updated',
    onMessage: "onMessage"
}